import { render, staticRenderFns } from "./RightDrawer.vue?vue&type=template&id=b61d4eb0&scoped=true"
import script from "./RightDrawer.vue?vue&type=script&lang=ts"
export * from "./RightDrawer.vue?vue&type=script&lang=ts"
import style0 from "./RightDrawer.vue?vue&type=style&index=0&id=b61d4eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61d4eb0",
  null
  
)

export default component.exports